import {
  BASE_PRICE_REQUEST,
  BASE_PRICE_SUCCESS,
  BASE_PRICE_ERROR,
  FACTORS_REQUEST,
  FACTORS_SUCCESS,
  FACTORS_ERROR,
  CLEAR_PRODUCT_STORE, } from '../actions/product';

import { getBasePrices } from '../../services/base_prices';
import { getFactors } from '../../services/factors';

function initialState() {
  return { currentBasePrices: {}, currentFactors: {}, error: '', status: '', }
}

const state = initialState();

const getters = {
  getCurrentBasePrice: state => state.currentBasePrice,
  getCurrentFactors: state => state.currentFactors,
};

const actions = {
  [BASE_PRICE_REQUEST]: async ({ commit, dispatch }) => {
    commit(BASE_PRICE_REQUEST);
    await getBasePrices()
      .then(response => {
        commit(BASE_PRICE_SUCCESS, response);
      })
      .catch(err => {
        commit(BASE_PRICE_ERROR, err);
      });
    commit(FACTORS_REQUEST);
    await getFactors()
      .then((response => {
        commit(FACTORS_SUCCESS, response);
      }))
      .catch(err => {
        commit(FACTORS_ERROR, err);
      });
  },
  [CLEAR_PRODUCT_STORE]: ({commit}) => {
    commit(CLEAR_PRODUCT_STORE);
  },
};

const mutations = {
  [BASE_PRICE_REQUEST]: state => {
    state.status = 'loading';
  },
  [BASE_PRICE_SUCCESS]: (state, resp) => {
    state.status = 'success';
    state.currentBasePrices = resp.data;
  },
  [BASE_PRICE_ERROR]: (state, resp) => {
    state.status = 'error';
    state.error = resp.data.message;
  },
  
  [FACTORS_REQUEST]: state => {
    state.status = 'loading';
  },
  [FACTORS_SUCCESS]: (state, resp) => {
    state.status = 'success';
    state.currentFactors = resp.data;
  },
  [FACTORS_ERROR]: (state, resp) => {
    state.status = 'error';
    state.error = resp.data.message;
  },
  [CLEAR_PRODUCT_STORE]: (state) => {
    const s = initialState();
    Object.keys(s).forEach( key => {
      state[key] = s[key];
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
}